<template>
  <grid-stack
    v-if="data.length"
    :data="data"
    :customizeSizing="customizeSizing"
  />
</template>

<script>
import GridStack from './../templates/widgets/GridStack'

export default {
  name:       'DashboardGridStack',
  components: {
    GridStack
  },
  props:      {
    data:            {
      type:    Array,
      default: function () {
        return []
      }
    },
    customizeSizing: {
      type:    Boolean,
      default: true
    }
  }
}
</script>
